import React, { useState, useEffect } from 'react';
import "./style.css";
import { CourseSaleCountdown } from '../CourseSaleCountdown';

export const CourseInfo = ({
  language,
  already_bought = false,
  number_lessons_text,
  under_price_text,
  under_action_button_text,
  subtitles_languages_text,
  course_level_text,
  course_has_certificate,
  audio_languages_text,
  product_id,
  product_currency,
  original_price,
  current_price,
  current_section,
  setTopPriceShown,
  isMobile,
  fb_event_id,
  presale,
  countdownRemainingTime
}) => {


  const translations = {
    "en": {
      "buy_now": presale ? "SECURE YOUR SPOT" : "ENROLL NOW",
      "gift_course": "GIFT THIS PACK",
      "go_to_course": "Go to course",
      "resources_pdf": "Resources in PDF",
      "subtitles": "Subtitles",
      "unlimited_access": "Unlimited Access",
      "buynow_paylater": "Buy now, pay later",
      "mobile_desktop_access": "Access on mobile & desktop",
      "certificate": "Certificate of participation",
    },
    "es": {
      "buy_now": presale ? "RESERVA TU PLAZA" : "INSCRÍBETE AHORA",
      "gift_course": "REGALAR ESTE PACK",
      "go_to_course": "Ir al curso",
      "resources_pdf": "Recursos en PDF",
      "subtitles": "Subtítulos",
      "unlimited_access": "Acceso ilimitado",
      "buynow_paylater": "Compra ahora, paga después",
      "mobile_desktop_access": "Acceso desde móvil y PC",
      "certificate": "Certificado de participación",
    },
    "pt": {
      "buy_now": presale ? "RESERVE SUA VAGA" : "INSCREVA-SE AGORA",
      "gift_course": "PRESENTEAR ESTE PACK",
      "go_to_course": "Aceder ao curso",
      "resources_pdf": "Recursos em PDF",
      "subtitles": "Legendas",
      "unlimited_access": "Acesso ilimitado",
      "buynow_paylater": "Comprar agora, pagar depois",
      "mobile_desktop_access": "Acesso em dispositivos móveis e desktop",
      "certificate": "Certificado de participação",
    },
    "fr": {
      "buy_now": presale ? "RÉSERVEZ VOTRE PLACE" : "INSCRIVEZ-VOUS MAINTENANT",
      "gift_course": "OFFRIR CE PACK EN CADEAU",
      "go_to_course": "Accéder au cours",
      "resources_pdf": "Ressources en PDF",
      "subtitles": "Sous-titres",
      "unlimited_access": "Accès illimité",
      "buynow_paylater": "Acheter maintenant, payer plus tard",
      "mobile_desktop_access": "Accès depuis mobile et PC ",
      "certificate": "Certificat de participation",
    }
  };


  const getTrans = (text) => {

    return translations[language][text];

  }


  const [isCompacted, setCompacted] = React.useState(false);
  const [forceUpdateFlag, setForceUpdateFlag] = useState(false);

  //const fb_event_id = Math.floor(Math.random() * 1000000000);

  const handleScroll = (e) => {

    //let distance = document.getElementById('course_info_div').scrollTop + document.getElementById('course_info_div').height;

    let div_distance = document.getElementById('course_info_div').clientHeight;
    let close_distance = div_distance + 100; // TODO - improve
    let open_distance = div_distance + 80; // TODO - improve


    if ((window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop) > open_distance) {
      setCompacted(true);
      setTopPriceShown(true);
      return;
    }

    if ((window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop) < close_distance) {
      setCompacted(false);
      setTopPriceShown(false);
    }


  };

  useEffect(() => {

    const handleResize = () => {
      // Actualiza el estado para forzar una nueva renderización
      setForceUpdateFlag((prevFlag) => !prevFlag);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    // Not mobile, do not show top bar
    //if (document.body.clientWidth > 1199)
    //  return;

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    }

  }, []);

  function gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }


  const addToCartFB = () => {

    console.info("AddToCart to FB Pixel. event_id: " + fb_event_id);

    const value = parseFloat(current_price);
    window.fbq('track', 'AddToCart', { "currency": product_currency, "item_number": product_id, "value": value }, { eventID: fb_event_id });
    //gtag('event', 'add_to_cart', { "currency": product_currency, "item_id": product_id, "value": value , "eventID": fb_event_id });

    // Fixed for Google Tag Manager
    window.dataLayer.push(
			{"event": "add_to_cart",
			 //"transaction_id": ,
			 "value": value,
			 "currency": product_currency,
			 "item_id": product_id,
			 "eventID": fb_event_id}
		);

  }

  const buyAction = (e) => {

    e.preventDefault();
    document.querySelectorAll('.course_info_action_button').forEach(element => {
      element.disabled = true;
      setTimeout(() => element.disabled = false, 5000);
    });

    document.querySelectorAll('.course_info_toolbar_action_button').forEach(element => {
      element.disabled = true;
      setTimeout(() => element.disabled = false, 5000);
    });

    if (window.consent_cookie.analytics_storage == "granted")
      addToCartFB();

    document.getElementById("is_gift_input").value = "0";

    document.getElementById("buy_product_form").submit();

  };

  const giftAction = (e) => {

    e.preventDefault();
    document.querySelectorAll('.course_info_action_button').forEach(element => {
      element.disabled = true;
      setTimeout(() => element.disabled = false, 5000);
    });

    document.querySelectorAll('.course_info_toolbar_action_button').forEach(element => {
      element.disabled = true;
      setTimeout(() => element.disabled = false, 5000);
    });

    if (window.consent_cookie.analytics_storage == "granted")
      addToCartFB();

    document.getElementById("is_gift_input").value = "1";

    document.getElementById("buy_product_form").submit();

  };

  return (
    <>

      <form id="buy_product_form" action={`https://www.10masters.com/${language}/basket/add/${product_id}/${product_currency}/`} method="post">
        <input type="hidden" name="quantity" value="1" id="id_quantity" />
        <input type="hidden" name="fb_event_id" value={fb_event_id} />
        <input id="is_gift_input" type="hidden" name="gift" value="0" />
      </form>

      <div className={`course_info_toolbar_div ${isCompacted || (current_section !== 'overview' && isMobile) ? '' : 'd-none'}`}>
        <div className="course_info_toolbar_wrapper">
          {
            already_bought ?
              <a className="course_info_toolbar_action_button my-auto" href="https://lms.10masters.com">{getTrans("go_to_course")}</a>
              :
              <>
                <div className="course_info_prices_toolbar my-auto">
                <span dangerouslySetInnerHTML={{ __html: current_price }} className="course_info_price"></span> <span dangerouslySetInnerHTML={{ __html: original_price }} className="course_info_old_price"></span>
                </div>

                <button onClick={buyAction} className="course_info_toolbar_action_button my-auto" href="#">{getTrans("buy_now")}</button>

              </>
          }
          </div>
      </div>

      <div id="course_info_div" className={`course_info_div ${(current_section === 'overview' || !isMobile) ? '' : 'd-none'}`}>

        {
          already_bought ?
            <a className="course_info_action_button" href="https://lms.10masters.com">{getTrans("go_to_course")}</a>
            :
            <>
              <div className="course_info_prices">
                <span className="course_info_price" dangerouslySetInnerHTML={{ __html: current_price }}></span> <span dangerouslySetInnerHTML={{ __html: original_price }} className="course_info_old_price"></span>
              </div>
              <div className="under_price_text mb-3">{under_price_text}</div>

              { !presale &&
                <CourseSaleCountdown language={language} remainingTime={countdownRemainingTime} />
              }

              <button onClick={buyAction} className="course_info_action_button" href="#">{getTrans("buy_now")}</button>
              <button onClick={giftAction} className="course_info_gift_button" href="#"><img style={{height: "15px", verticalAlign: "baseline"}} src="https://w.10masters.com/static/icons/gift.svg" alt="[Gift]" /> {getTrans("gift_course")}</button>

            </>
        }

        <div className="under_action_button_text" dangerouslySetInnerHTML={{ __html: under_action_button_text }}></div>

        <div className="course_info_features mb-3">

          <p className="mt-4 course_info_font">
            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-card-checklist" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" d="M14.5 3h-13a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"></path>
              <path fillRule="evenodd" d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"></path>
            </svg>
            <span className="align-middle">&nbsp; {number_lessons_text}</span>
          </p>

          <p className="course_info_font">
            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-folder2-open" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v.64c.57.265.94.876.856 1.546l-.64 5.124A2.5 2.5 0 0 1 12.733 15H3.266a2.5 2.5 0 0 1-2.481-2.19l-.64-5.124A1.5 1.5 0 0 1 1 6.14V3.5zM2 6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3H2.5a.5.5 0 0 0-.5.5V6zm-.367 1a.5.5 0 0 0-.496.562l.64 5.124A1.5 1.5 0 0 0 3.266 14h9.468a1.5 1.5 0 0 0 1.489-1.314l.64-5.124A.5.5 0 0 0 14.367 7H1.633z"></path>
            </svg>
            <span className="align-middle">&nbsp; {getTrans("resources_pdf")}</span>
          </p>

          <p className="course_info_font">
            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-hourglass-split" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0c0 .701.478 1.236 1.011 1.492A3.5 3.5 0 0 1 11.5 13s-.866-1.299-3-1.48V8.35z"></path>
            </svg>
            <span className="align-middle">&nbsp; {getTrans("unlimited_access")}</span>
          </p>

          <p className="course_info_font">
            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-mic-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0V3z"></path>
              <path fillRule="evenodd" d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z"></path>
            </svg>
            <span className="align-middle">&nbsp; Audio: {audio_languages_text}</span>
          </p>

          <div className="course_info_font margin_bot_1rem_not">
            <div className="d-flex info_subtitles_gap">

              <div className="">
                <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-chat-right-text" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M2 1h12a1 1 0 0 1 1 1v11.586l-2-2A2 2 0 0 0 11.586 11H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z"></path>
                  <path fillRule="evenodd" d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"></path>
                </svg>
              </div>
              <div className="">
                {getTrans("subtitles")}: {subtitles_languages_text}
              </div>
            </div>

          </div>

          <p className="course_info_font">
            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-graph-up" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" d="M0 0h1v15h15v1H0V0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5z"></path>
            </svg>
            <span className="align-middle">&nbsp; {course_level_text}</span>
          </p>

          <p className="course_info_font">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" className="bi bi-phone" viewBox="0 0 16 16">
              <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"></path>
              <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"></path>
            </svg>
            <span className="align-middle">&nbsp; {getTrans("mobile_desktop_access")}</span>
          </p>

          {
            course_has_certificate ?
              <p className="course_info_font">
                <img loading="lazy" style={{ width: '1em' }} src="https://w.10masters.com/static/icons/certificado_black.svg" alt="CERT" />
                <span className="align-middle">&nbsp; {getTrans("certificate")}</span>
              </p>
              :
              <></>
          }

        </div>

        <div className="d-flex flex-nowrap mx-auto payment_icons_first_container flex-grow-0 gap-1">
          <div className="d-flex justify-content-center align-items-center flex-grow-0 flex-shrink-0">
            <img style={{"width": "48px", "height": "20px"}} alt="STRIPE" loading="lazy" src="https://w.10masters.com/static/reactweb_icons/stripe_20px.png" />
          </div>

          <div>
            <img className="rounded payment_icon" alt="VISA" loading="lazy" src="https://w.10masters.com/static/reactweb_icons/visa.jpg" />
          </div>

          <div>
            <img className="rounded payment_icon" alt="AMERICAN EXPRESS" loading="lazy" src="https://w.10masters.com/static/reactweb_icons/americanexpress.jpg" />
          </div>

          <div>
            <img className="rounded payment_icon" alt="MASTERCARD" loading="lazy" src="https://w.10masters.com/static/reactweb_icons/mastercard.jpg" />
          </div>

          <div>
            <img className="rounded payment_icon" alt="MAESTRO" loading="lazy" src="https://w.10masters.com/static/reactweb_icons/maestro.jpg" />
          </div>
        </div>

        <div className="d-flex flex-nowrap mx-auto payment_icons_first_container flex-grow-0 gap-1 align-items-center">
          <div className="d-flex justify-content-center align-items-center flex-grow-0 flex-shrink-0">
            <img style={{"visibility": "hidden", "width": "48px", "height": "20px"}} alt="STRIPE" loading="lazy" src="https://w.10masters.com/static/reactweb_icons/stripe_20px.png" />
          </div>
          <div>
            <img className="rounded payment_icon" alt="PAYPAL" loading="lazy" src="https://w.10masters.com/static/reactweb_icons/paypal.jpg" />
          </div>
          <div className="paypal_paylater_text">({getTrans("buynow_paylater")})</div>
        </div>
        
      </div>
    </>

  );
};
